import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadersState } from '../reducers/loaders.reducer';
import { LOADERS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<LoadersState>(LOADERS_FEATURE_KEY);
export const selectLoading = createSelector(selectState, (state: LoadersState) => state.ids.length > 0);
